import { TextInputCustomField } from './TextInputCustomField'
import { withTextInputCustomField } from './withTextInputCustomField'

const ConnectedTextInputCustomField =
  withTextInputCustomField(TextInputCustomField)

export { ConnectedTextInputCustomField as TextInputCustomField }
